import { useAppSelector } from "@repo/logic";
import { useEffect } from "react";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { ChangeRequestResultPage } from "../ChangeRequestResultPage";
import { DefaultStepProps } from "../Stepper/CustomStepper";

export const RequestSentPage: React.FC<DefaultStepProps> = ({ hidePrevButton }) => {
    const { t } = useTypedTranslation();
    const isChangeContributionSuccessful = useAppSelector((state) => state.stepper.isChangeContributionSuccessful); //Check if the request on SMSVerificationPage was successful
    const isLoading = isChangeContributionSuccessful === null;

    // Prev button should be hidden on this page (as going back makes no sense)
    useEffect(() => {
        hidePrevButton?.();
    }, [hidePrevButton]);

    if (isLoading) {
        return <ChangeRequestResultPage status="success" isLoading />;
    }

    if (isChangeContributionSuccessful) {
        return <ChangeRequestResultPage status="success" />;
    }
    return (
        <ChangeRequestResultPage status="failed" bodyText={t("changeRequestResult.failed.body")} bodyVariant="banner" />
    );
};
